// extracted by mini-css-extract-plugin
export default {"container":"Outline_container__9Mn4R","containerShown":"Outline_containerShown__i35TU","badgeContainer":"Outline_badgeContainer__OYqs7"};